<template>
<div id="chat_last">

	<div class="profilewrapper" v-if="userinfo">
        <userpic :userinfo="userinfo"/>
    </div>

	<template v-if="canloadstory">

		<div class="caption">
			<span>{{$t('snippity.chatLastMessage')}}</span>
		</div>

		<div class="form">
			<select class="custom" v-model="locale">
				<option :value="locale.value" v-for="(locale, i) in locales" :key="i">{{$t(locale.text)}}</option>
			</select>
		</div>

		<div class="buttonWrapper">
			<button class="button" :disabled="getting" @click="getstory">{{$t('yes')}}</button>
		</div>

		

	</template>

	<template v-else>

		<div class="caption">
			<span>{{$t('snippity.chatLastMessageNomessages')}}</span>
		</div>

		<div class="buttonWrapper">
			<button class="button orange big" @click="gotocourses">{{$t('snippity.course.gotocourses')}}</button>
		</div>

	</template>

	<div class="logowrapper">
		<logotype />
	</div>

</div>
</template>

<style scoped lang="sass">

#chat_last
	display: flex
	flex-flow: column
	justify-content: center
	align-items: center

	.form
		margin-top: 4 * $r

	.profilewrapper
		margin-top: 2 * $r
		margin-bottom: 2 * $r

		.userpic
			width: 44px
			height: 44px
			line-height: 44px
            
			+shadowSmaller()

			::v-deep
				.charAvatar,
				.statusIcon
					font-size: 1em

	.caption
		text-align: center
		max-width: 300px
		color : srgb(--neutral-grad-4)

		span
			font-size: 1.5em
			font-weight: 700

	.buttonWrapper
		margin-top: 4 * $r
		margin-bottom: 4 * $r

	.logowrapper
		margin-top: 2 * $r

</style>

<script>
import {
	mapState
} from 'vuex';

export default {
	name: 'chat_intro',
	props: {
	},
	computed: mapState({
		auth: state => state.auth,
		userinfo: state => state.userinfo,

		
	}),

	created() {
		this.locale = (this.userinfo?.userinfo.locale || 'any')

		this.checkget()
	},

	data : function(){

        return {
			loading : false,
			canloadstory : null,
			getting : false,
            locale : 'any',
			locales : [{
				value : 'any',
				text : 'snippity.snippity_last_locale_any'
			},{
				value : 'en',
				text : 'snippity.snippity_last_locale_en'
			}, {
				value : 'ru',
				text : 'snippity.snippity_last_locale_ru'
			}]
        }

    },

	methods: {
		checkget : function(){
			/*this.core.api.stories.canGetStoryToMe().then((r) => {
				this.canloadstory = r || null

				return Promise.resolve()
			}).catch(e => {
				this.canloadstory = null
			})*/
		},
		getstory : function(){
			

			var p = {}

			p.age = this.userinfo?.userinfo.age
			p.topic = 'news'

			if(this.locale != 'any') p.locale = this.locale

			this.getting = true

			this.core.api.stories.sendAnyStoryToMe(p).then(() => {

				this.effect({
					size : 15,
					duration : 2000
				})

				return this.checkget()

				//this.$emit('sendAnyStoryToMe')
				
			}).catch(e => {

				this.core.store.commit('icon', {
					icon: 'error',
					message: e.error || e || 'error'
				})

			}).finally(() => {
				this.getting = false
			}) 
		},

		effect : function(p = {}){
			if (this.core.infinityEffect){
                this.core.infinityEffect.play('stars', {
                    size : 15,
                    scatter : 100,
                    opacity : 0.8,
                    color : '#ffa000',
                    
                    from : {
                        y : window.innerHeight / 2,
                        x : window.innerWidth / 2
                    },

                    to : {
                        y : window.innerHeight,
                        x : window.innerWidth
                    },
                    ...p
                })
            }
		},
		gotocourses : function(){
			this.$router.push('/courses')
		}
	},
}
</script>
